$(document).ready(() => {
    broadcastSlider();
    freePlayersSlider();
    latestSlider();
    firstSlider();

    tournamentApplication();
    tournamentApplication(true);

    const timeMask = new window.Inputmask("99:99");
    $('.time-mask').each((index, element) => {
        timeMask.mask(element);
    });
    const percentMask = new window.Inputmask("99.9");
    $('.percent-mask').each((index, element) => {
        percentMask.mask(element);
    });

    $(".video-play").click(function(){
        let videoId = $(this).attr('data-id');
        let videoOid = $(this).attr('data-oid');
        let videoHash = $(this).attr('data-hash');
        let videoType = $(this).attr('data-type');

        if (videoType === 'youtube') {
            $(this).siblings('.video-play-img').html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + videoId + '?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>');
        } else if (videoType === 'vk') {
            // $(this).siblings('.video-play-img').html('<iframe src="https://vk.com/video_ext.php?oid=' + videoOid + '&id=' + videoId + '&hash=' + videoHash + '&hd=2"  width="100%" height="100%" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameborder="0" allowfullscreen></iframe>');
            // <iframe src="https://vkvideo.ru/video_ext.php?oid=-199072953&id=456239644&hd=2&autoplay=1" width="853" height="480" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>
            $(this).siblings('.video-play-img').html('<iframe src="https://vkvideo.ru/video_ext.php?oid=' + videoOid + '&id=' + videoId + '&hash=' + videoHash + '&hd=2"  width="100%" height="100%" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameborder="0" allowfullscreen></iframe>');
        }
        $(this).siblings('.video-play-img').css({'z-index' : 5});
        $(this).remove();
    });

    $('.payTournamentApplication').on('click', event => {
        event.preventDefault();
        const tournament_id = $(event.target).data('id');
        const type = $(event.target).data('type');
        TRNMNT_helpers.disableButtons();

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'post',
            url: '/ajax/' + type + '/' + tournament_id + '/application/pay',
            contentType: "application/json; charset=utf-8",
            processData: false,
            success: response => {
                TRNMNT_helpers.enableButtons();
                window.location.href = response.data.confirmation_url;
            },
            error: TRNMNT_helpers.onErrorAjax,
            context: TRNMNT_helpers
        });
    });
});

function tournamentApplication(isDeleting = false) {
    const mainSelector = isDeleting ? '.deleteTournamentApplication' : '.createTournamentApplication';
    const secondSelector = isDeleting ? '.createTournamentApplication' : '.deleteTournamentApplication';

    $(document).on('click', mainSelector, event => {
        event.preventDefault();
        const $this = $(event.target);
        const tournament_id = +$this.data('id');
        const is_group = $this.data('is-group');
        console.log(is_group);

        TRNMNT_helpers.disableButtons();
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: isDeleting ? 'delete' : 'post',
            url: '/ajax/' + (is_group ? 'tournaments' : 'versus') + '/' + tournament_id + '/application',
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            processData: false,
            success: () => {
                TRNMNT_helpers.enableButtons();

                const $parentBlock = $this.parent('div');
                const $template = $('#templates').find(secondSelector).clone();
                const classes = $this.prop("classList");
                const skipClasses = [
                    mainSelector.replace('.', ''),
                    secondSelector.replace('.', ''),
                    'btn',
                    'btn-primary',
                    'btn-danger',
                ];

                $this.remove();
                $template.data('id', tournament_id);
                $template.data('is-group', !is_group)
                for (let item of classes) {
                    if (skipClasses.indexOf(item) !== -1) {
                        continue;
                    }
                    $template.addClass(item);
                }
                $parentBlock.prepend($template);
            },
            error: TRNMNT_helpers.onErrorAjax,
            context: TRNMNT_helpers,
        });
    });
}

function broadcastSlider() {
    new Swiper(".broadcast .swiper-container", {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: !0,
        navigation: {nextEl: ".broadcast .swiper-button-next", prevEl: ".broadcast .swiper-button-prev"},
        breakpoints: {320: {slidesPerView: 1}, 1200: {slidesPerView: 2}}
    })
}

function freePlayersSlider() {
    new Swiper(".free-players .swiper-container", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: !0,
        navigation: {nextEl: ".free-players .swiper-button-next", prevEl: ".free-players .swiper-button-prev"},
        breakpoints: {320: {slidesPerView: 1}, 1200: {slidesPerView: 3}}
    })
}

function latestSlider() {
    new Swiper(".latest-matches .swiper-container", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: !0,
        navigation: {nextEl: ".latest-matches .swiper-button-next", prevEl: ".latest-matches .swiper-button-prev"},
        breakpoints: {320: {slidesPerView: 1}, 1400: {slidesPerView: 2}, 1700: {slidesPerView: 3}}
    })
}

function firstSlider() {
    new Swiper(".first-screen .swiper-container", {
        slidesPerView: "auto",
        spaceBetween: 30,
        slideToClickedSlide: !0,
        on: {
            init: function () {
                e(this.activeIndex + 1)
            }, slideChange: function () {
                e(this.activeIndex + 1)
            }
        }
    });

    function e(e) {
        $(".first-screen__btn").removeClass("_active"), $(`.first-screen__btn[data-slide="${e}"]`).addClass("_active")
    }
}
